import { render, staticRenderFns } from "./FormModal.vue?vue&type=template&id=22d1d22b&scoped=true"
import script from "./FormModal.vue?vue&type=script&lang=ts"
export * from "./FormModal.vue?vue&type=script&lang=ts"
import style0 from "./FormModal.vue?vue&type=style&index=0&id=22d1d22b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d1d22b",
  null
  
)

export default component.exports